import React from 'react';

export const ErrorMessage = () => {
    return (
        <div className='error'>
            <span>Please keep message between 1 to 140 characters</span>
        </div>
    );
};